.db{padding:0.5rem;}